<template>
    <section
        class="team section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="team-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div
                    class="tiles-wrap"
                    :class="[
                        pushLeft && 'push-left',
                    ]">

<!--
                    <div class="tiles-item reveal-scale-up" data-reveal-delay="200">
                        <div class="tiles-item-inner">
                            <div class="team-item-content">
                                <h5 class="team-item-name mt-0 mb-4">
                                    Fremantle Central Pharmacy
                                </h5>
                                <div class="team-item-role text-xs fw-500 mb-8">
                                    Shop 1,Cnr Cantonments st& Queens St, Fremantle
                                </div>
                                <p class="m-0 text-sm">
                                    o8 9335 2786
                                </p>
                            </div>
                        </div>
                    </div>
-->
                    <div class="tiles-item reveal-scale-up">
                        <div class="tiles-item-inner">
                            <div class="team-item-content">
                                <h5 class="team-item-name mt-0 mb-4">
                                    Line-1 北桥店
                                </h5>
                                <div class="team-item-role text-xs fw-500 mb-8">
                                    Suite 3, 1 Forbes Road, Perth, WA 6000
                                </div>
                                <p class="m-0 text-sm">
                                    每天
                                </p>
                            </div>
                        </div>
                    </div>

  

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="400">
                        <div class="tiles-item-inner">
                            <div class="team-item-content">
                                <h5 class="team-item-name mt-0 mb-4">
                                    Line-1 Cannington直营店
                                </h5>
                                <div class="team-item-role text-xs fw-500 mb-8">
                                    unit 3,1341 Albany Highway, Cannington,WA 6107
                                </div>
                                <p class="m-0 text-sm">
                                    每天
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'

export default {
  name: 'CTeam',
  components: {
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: 'Our story - Lorem ipsum is placeholder text.',
        paragraph:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      }
    }
  }
}
</script>